"use strict";
/* Copyright (c) 2020 Ezzat Chamudi
 *
 * This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at https://mozilla.org/MPL/2.0/.
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const get_block_names_1 = __importDefault(require("./get-block-names"));
function some(string, conditions) {
    if (string.length === 0)
        return true;
    if (conditions.length === 0)
        return true;
    const stringBlocks = get_block_names_1.default(string);
    const result = stringBlocks.some((stringBlock) => conditions.some((condition) => {
        if (condition.block !== undefined && condition.block !== stringBlock.block)
            return false;
        if (condition.subblock !== undefined && condition.subblock !== stringBlock.subblock) {
            return false;
        }
        return true;
    }));
    return result;
}
exports.default = some;
